export default {
    okx_address(){
        // return 'https://www.dflepam.cn/join/UPLUS2'
        // return 'https://www.sdchizhengjixie.com/join/UPLUS2'
        // return 'https://www.ouyicn.press/join/10523149'
        // return 'https://www.cnouyi.care/join/UPLUS3'
        // return 'https://www.tianyena.com/join/UPLUS3'
        return 'https://www.ouxyi.io/ul/6CngT5?channelId=UPLUS3'
    },
    binance_address(){
        return 'https://accounts.marketwebb.net/register?ref=37664683'
    },

    download_android_address(){
        return 'https://zdy4n.ivqrrox.com/HteKH/ntq2yta1zj'
    },

    download_ios_h5_address(){
        return 'https://dzq1ex60xijg4.cloudfront.net/d/app/UPlus/index.html'
    },

    download_ios_beta_address(){
        return 'https://testflight.apple.com/join/z5P0yjyt'
    },

    download_ios_p_address(){
        return 'https://zdy4n.ivqrrox.com/HteKH/ntq2yta1zj'
    },

    download_ios_address(){
        // return 'https://u.ppx6.com/5aad59'
        return 'https://fyoss.fy5.co/d7mt2d'
    }
}
